<div class="dialog-container">
  <div class="dialog-header">
    <div class="user-edit-icon">
      <img src="assets/images/user-circle.png" class="dialog-icon" alt="User Icon" />
    </div>
    <h2 class="dialog-title">Edit Health Info</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="healthForm" class="dialog-form">
    <div class="form-row">
      <mat-form-field appearance="outline" step="0.01" class="half-width">
        <mat-label>Height ({{height}}) </mat-label>
        <input matInput type="number" min="0" formControlName="height" (input)="onNumberInput($event, 'height')"/>
         <mat-error *ngIf="getError('height') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dropdown-width">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="heightUnit">
          <mat-option value="cm">cm</mat-option>
          <mat-option value="inch">inch</mat-option>
          <mat-option value="feet">feet</mat-option>
        </mat-select>
      </mat-form-field>
      </div>
      <div class="form-row">

      <mat-form-field appearance="outline" class="half-width">
        <mat-label>Weight ({{weight }}) </mat-label>
        <input matInput type="number" step="0.01" min="0" formControlName="weight" (input)="onNumberInput($event, 'weight')"/>
         <mat-error *ngIf="getError('weight') as err">{{ err }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="dropdown-width">
        <mat-label>Unit</mat-label>
        <mat-select formControlName="weigthtUnit">
          <mat-option value="kg">kg</mat-option>
          <mat-option value="lbs">lbs</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Blood Group </mat-label>
      <mat-select formControlName="bloodGroup">
        <mat-option *ngFor="let group of bloodGroups" [value]="group.title">{{ group.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('bloodGroup') as err">{{ err }}</mat-error>
    </mat-form-field>
    <div class="form-row">
      <mat-form-field appearance="outline" class="half-width">
       <mat-label>Date Of Birth</mat-label>
        <input matInput [matDatepicker]="picker" [max]="maxDate" formControlName="dob" required readonly (click)="picker.open()"/>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="getError('dob') as err">{{ err }}</mat-error>
      </mat-form-field>
    <mat-form-field appearance="outline" class="half-width">
         <mat-label>Gender</mat-label>
      <mat-select formControlName="gender">
        <mat-option *ngFor="let option of gender_list" [value]="option">{{ option }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('gender') as err">{{ err }}</mat-error>
      </mat-form-field>
    </div>
    

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Ethnicity</mat-label>
      <mat-select formControlName="ethnicity">
        <mat-option *ngFor="let option of ethnicities" [value]="option.title">{{ option.title }}</mat-option>
      </mat-select>
      <mat-error *ngIf="getError('ethnicity') as err">{{ err }}</mat-error>
    </mat-form-field>

    <div class="dialog-actions">
      <button mat-stroked-button color="primary" (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  </form>
</div>
